import {
  createListAllQuery,
  getMeal,
  GetMealQuery,
  GetMealQueryVariables,
  graphqlCall,
  listMeals,
  ListMealsQuery,
  ListMealsQueryVariables,
  Meal,
  mealByHabitat,
  MealByHabitatQueryVariables,
} from '@akin-home/amplify';
import { addWeeks } from 'date-fns';
import { mealGraphqlToModel } from '../functions';

export const listMealsQuery = (params: ListMealsQueryVariables) =>
  graphqlCall<ListMealsQuery>(listMeals, params);

export const listAllMealsQuery = createListAllQuery<
  Meal,
  ListMealsQueryVariables
>(listMeals, 'listMeals');

export const listAllMealsByHabitatQuery = createListAllQuery<
  Meal,
  MealByHabitatQueryVariables
>(mealByHabitat, 'mealByHabitat');

export const getMealQuery = (params: GetMealQueryVariables) =>
  graphqlCall<GetMealQuery>(getMeal, params);

export const getMealsForWeek = async ({
  date,
  habitatID,
}: {
  date: Date;
  habitatID: string;
}) => {
  const mealsForWeek = await listAllMealsByHabitatQuery({
    habitatID,
    filter: {
      or: [
        {
          start: {
            between: [date.toISOString(), addWeeks(date, 1).toISOString()],
          },
        },
        {
          recurrenceUntil: {
            gt: date.toISOString(),
          },
        },
      ],
    },
  });

  return mealsForWeek.map(mealGraphqlToModel);
};
